/**
* Breadcrumbs Functions
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()
  const { $member } = useNuxtApp()

  /**
  * Breadcrumps
  */
  const breadcrumbs = useState('breadcrumbs', () => [])

  /**
  * Get Breadcrumps
  */
  const getBreadcrumbs = (pageData, layout) => {
    const { params } = useRoute()

    const breadcrumbsNew = [{
      label: i18n?.t('breadcrumbs.index'),
      route: '/',
      icon: ''
    }]

    /**
    * Catalog & Product
    */
    if (layout === 'catalog' || layout === 'product') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.products'),
        route: '/catalog/products'
      })

      /**
      * Catalog
      */
      if (pageData?.data?.title && layout !== 'product' && pageData.urlPathName !== 'products') {
        breadcrumbsNew.push({
          label: pageData.data.title,
          route: ''
        })
      }

      /**
      * Product
      */
      if (pageData && layout === 'product') {
        if (pageData?.product?.breadcrumbs) {
          const productBreadcrumbs = pageData.product.breadcrumbs.filter(n => n && n.type === 'category')
          delete productBreadcrumbs[0]
          if (productBreadcrumbs) {
            productBreadcrumbs.forEach((item) => {
              const pathName = item.pathname.split('/')[item.pathname.split('/').length - 1]
              breadcrumbsNew.push({
                label: item.title,
                route: '/catalog/' + pathName + '-' + item.id
              })
            })
          }
        }

        if (pageData?.product?.producttitle) {
          breadcrumbsNew.push({
            label: pageData.product.producttitle,
            route: ''
          })
        }
      }
    }

    /**
    * Page
    */
    if (pageData && pageData.page && layout === 'page') {
      breadcrumbsNew.push({
        label: pageData.page.headTitle,
        route: ''
      })
    }

    /**
    * Sitemap
    */
    if (layout === 'sitemap') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.sitemap'),
        route: '/sitemap'
      })
    }

    /**
    * Search
    */
    if (layout === 'search') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.search'),
        route: '/search'
      })
    }

    /**
    * Cart
    */
    if (layout === 'cart') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.cart'),
        route: '/cart'
      })
    }

    /**
    * Checkout
    */
    if (layout === 'checkout' || layout === 'order-success') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.checkout'),
        route: '/checkout'
      })
    }

    /**
    * Order Success
    */
    if (layout === 'order-success') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.orderSuccess'),
        route: ''
      })
    }

    /**
    * Entry
    */
    if (layout === 'entry') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.entry'),
        route: ''
      })
    }

    /**
    * FAQ
    */
    if (layout === 'faq') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.faq')
      })
    }

    /**
    * NotFound
    */
    if (layout === 'notFound') {
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.notFound')
      })
    }

    /**
    * Customer
    */
    if (layout === 'customer') {
      let link = '/customer'
      breadcrumbsNew.push({
        label: i18n?.t('breadcrumbs.customer'),
        route: '/customer/information'
      })

      if (params.params) {
        if (params.params[0] && $member.customerRoutes?.find(n => n.name === params.params[0])) {
          link += '/' + params.params[0]
          const routeTitle = $member.customerRoutes?.find(n => n.name === params.params[0]).title

          breadcrumbsNew.push({
            label: routeTitle,
            route: params.params[1] ? link : false
          })
        } else if (params.params[0] && $member.settingRoutes?.find(n => n.name === params.params[0])) {
          link += '/' + params.params[0]
          const routeTitle = $member.settingRoutes?.find(n => n.name === params.params[0]).title

          breadcrumbsNew.push({
            label: routeTitle,
            route: params.params[1] ? link : false
          })
        } else if (params.params[0] && $member.supportRoutes?.find(n => n.name === params.params[0])) {
          link += '/' + params.params[0]
          const routeTitle = $member.supportRoutes?.find(n => n.name === params.params[0]).title

          breadcrumbsNew.push({
            label: routeTitle,
            route: params.params[1] ? link : false
          })
        }

        if (params.params[1]) {
          link += '/' + params.params[1]
          const routeTitle = params.params[1] === 'create'
            ? i18n?.t('customerRoutes.create')
            : i18n?.t('customerRoutes.details')

          breadcrumbsNew.push({
            label: routeTitle,
            route: link
          })
        }
      }
    }

    breadcrumbs.value = breadcrumbsNew

    return breadcrumbsNew
  }

  /**
  * Return Object
  */
  return {
    breadcrumbs,
    getBreadcrumbs
  }
}
